<template>
  <div class="proxers" style="width: 100%">
    <drawer-dialog
      v-model="openSettingForm"
      :is-loading="isLoading"
      width="70%"
    >
      <proxer-settings
        v-if="openSettingForm"
        :systemList="systemList"
        :brandList="brandList"
        :providerList="providers"
        :entitiesMap="entitiesMap"
        :is-loading="isLoading"
        :readonly="false"
        :proxer="currentSettingData ?? undefined"
        @close="() => openSettingForm = false"
        @save="saveProxerSetting"
      >
        PROXER SETTINGS
      </proxer-settings>
    </drawer-dialog>
    <v-row class="mx-0 justify-space-between">
      <v-btn
        color="primary"
        @click="addNewProxer"
      >
        Add new proxer
      </v-btn>
      <custom-proxer
        v-if="$store.state.auth.checkAccess({key: 'custom_proxer', value: true})"
        :brandList="brandList"
      />
    </v-row>

    <v-data-iterator
      :custom-sort="sortByTitle"
      :custom-filter="filterBy"
      :items="proxers"
      :loading="isLoading"
      :sort-desc="sortBy"
      item-key="entity_id"
      fixed-header
      style="height: calc(100% - 150px)"
      :class="{'dt-table': true, 'footer-padding': $store.state.auth.checkAccess({key: 'kiosk.access', value: true})}"
    >
      <template v-slot:header>
        <v-card class="mt-3">
          <v-row class="mx-0 pa-4 align-center" style="gap: 1rem;">
            <v-icon v-text="'mdi-filter'" />
            <strong v-text="'Filter By:'" />
            <v-select
              v-model="sortBy"
              label="Sort brand by"
              :items="sortList"
              auto-select-first
              outlined
              dense
              hide-details
              color="purple"
              style="min-width: 170px; max-width: 170px"
            />
            <v-select
              v-model="filters.status.value"
              label="Status"
              :items="status"
              outlined
              dense
              multiple
              hide-details
              color="purple"
              style="min-width: 170px; max-width: 170px"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">
                  {{ item.text }} <span v-if="filters.status.value.length > 1">(+{{ filters.status.value.length - 1 }})</span>
                </span>
              </template>
            </v-select>
            <v-select
              v-model="filters.system.value"
              label="System"
              :items="formattedConfigOptions.systems"
              outlined
              dense
              multiple
              hide-details
              color="purple"
              style="min-width: 170px; max-width: 170px"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">
                  {{ item.text }} <span v-if="filters.system.value.length > 1">(+{{ filters.system.value.length - 1 }})</span>
                </span>
              </template>
            </v-select>
            <v-select
              v-model="filters.brand.value"
              label="Brand"
              :items="formattedConfigOptions.brands"
              outlined
              dense
              multiple
              hide-details
              color="purple"
              style="min-width: 170px; max-width: 170px"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">
                  {{ item.text }} <span v-if="filters.brand.value.length > 1">(+{{ filters.brand.value.length - 1 }})</span>
                </span>
              </template>
            </v-select>
            <v-select
              v-model="filters.countries.value"
              label="Countries"
              :items="formattedConfigOptions.countries"
              outlined
              dense
              multiple
              hide-details
              color="purple"
              style="min-width: 170px; max-width: 170px"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">
                  {{ item.text }} <span v-if="filters.countries.value.length > 1">(+{{ filters.countries.value.length - 1 }})</span>
                </span>
              </template>
            </v-select>
            <v-btn
              color="primary"
              v-text="'Filter'"
            />
          </v-row>
        </v-card>
      </template>
      <template v-slot:default="{ items }">
        <div class="bulk-actions d-flex align-center mt-2 pl-2" v-if="hasAnySelectedConfigs">
          <div class="checkbox">
            <v-checkbox
              :value="selectedFlag"
              class="mt-5 mr-0"
              :indeterminate="selectedFlag !== null"
              on-icon="mdi-minus-box"
              hide-details
              @change="chooseAll"
            ></v-checkbox>
          </div>
          <div class="bulk-selects">
            <div
              v-for="(item, index) in selectedItems"
            >
              <span class="font-weight-bold caption">{{ item.title }}:</span>
              <v-select
                v-model="item.selected"
                :items="item.select"
                multiple
                outlined
                dense
                hide-details
                class="bulk-actions-select"
                style="max-width: 200px"
                @change="(selected) => handleBulkChange(item, selected)"
              >
                <template v-slot:selection="{ index }">
                  <div v-if="index === 0 || index === 1 || index === 2">
                    <span class="body-2">{{ item.selected[index] }}<span v-if="index < 2 && index < item.selected.length - 1">,&nbsp;</span></span>
                  </div>
                  <span
                    v-if="index === 3"
                    class="grey--text text-caption bulk-actions-select-others"
                  >
      &nbsp;(+{{ item.selected.length - 3 }} others)
    </span>
                </template>
              </v-select>
            </div>
            <div>
              <span class="font-weight-bold caption">Action:</span>
              <v-select
                v-model="action"
                :items="actionList"
                outlined
                dense
                hide-details
                class="body-2"
                style="max-width: 200px"
              ></v-select>
            </div>
            <div @click="deleteBulkedFilter" class="d-flex align-center mt-5" style="cursor: pointer">
              <v-icon>mdi-trash-can</v-icon>
            </div>
            <div class="d-flex align-center mt-5">
              <v-btn
                color="primary"
                :loading="isLoadingBulk"
                v-text="'Apply'"
                @click="applyBulkAction"
              />
            </div>
          </div>
        </div>
        <v-divider class="mt-4 mb-2"></v-divider>
        <proxer-project-card
          v-for="(proxer, index) in items"
          :key="`${proxer?.entity_id}-${proxer?.prefix}-${proxer?.projectTitle}`"
          :proxerData="proxer"
          :bulkedProxer="uniqBulkedProxers"
          :entityId="1000"
          :isSelectedAll="selectedFlag"
          :providerList="providers"
          @selectAll="addProjectToList"
          @selectSystems="({ added, item }) => updateSystemToList(added, item, proxer)"
          @edit="editProxer(proxer)"
          @switchProxerStatus="(isEnabledData) => switchProxerStatus(isEnabledData, index)"
          class="my-4"
        />
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
  import ProxerProjectCard from './ProxerProjectCard.vue'
  import { API } from '@/utils/api'
  import DrawerDialog from '@/components/core/DrawerDialog/DrawerDialog.vue'
  import ProxerSettings from '@/modules/proxers/components/ProxerSettings.vue'
  import CustomProxer from '@/components/helper/CustomProxer.vue'
  import { filters } from '@/utils/filters'
  import { mapGetters } from 'vuex'
  import { findIndex, keyBy } from 'lodash'

  const SKELETON_BULKED_PROXERS = {
    system: [],
    projectTitle: [],
    brand: [],
    countries: [],
  }
  export default {
    components: {
      ProxerProjectCard,
      ProxerSettings,
      DrawerDialog,
      CustomProxer
    },
    data () {
      return {
        sortBy: true,
        items: [],
        sortList: [
          { text: 'A-Z', value: true },
          { text: 'Z-A', value: false }
        ],
        status: [
          { value: true, text: 'Enabled' },
          { value: false, text: 'Disabled' },
        ],
        filters: {
          system: {
            value: []
          },
          status: {
            value: []
          },
          brand: {
            value: []
          },
          countries: {
            value: []
          },
        },
        openSettingForm: false,
        currentSettingData: null,
        isNewProxer: false,
        selectedFlag: null,
        isLoading: false,
        isLoadingBulk: false,
        massChoice: false,
        action: true,
        proxers: [],
        systemList: [],
        brandList: [],
        entitiesMap: [],
        providers: [],
        actionList: [
          { text: 'Enable', value: true },
          { text: 'Disable', value: false }
        ],
        bulkedProxers: _.cloneDeep(SKELETON_BULKED_PROXERS)
      }
    },
    mounted () {
      this.get()
      this.getProviders()
    },
    watch: {
      openSettingForm () {
        if (!this.openSettingForm) {
          this.currentSettingData = null
        }
      },
    },
    computed: {
      ...mapGetters({ activeAccount: 'account/active', infoTab: 'account/infoTab' }),

      uniqBulkedProxers () {
        const flattenedData = _.flatMap(this.bulkedProxers)

        const uniqueByAccessListId = _.uniqBy(flattenedData, 'accesslist_id')
        return uniqueByAccessListId
      },
      formattedConfigOptions () {
        const getUniqueValuesByKey = (key) => {
          const sourceItems = this.filteredItems.length > 0 ? this.filteredItems : this.proxers
          return [ ...new Set(sourceItems.flatMap(proxer => proxer.systemBrandConfigs.flatMap(config => config[key]))) ]
            .filter(item => item != null)
        }
        const formatOptionForSelect = (key) => {
          return getUniqueValuesByKey(key).map(item => ({
            value: item,
            text: item
          }))
        }

        return {
          projects: formatOptionForSelect('projectTitle'),
          systems: formatOptionForSelect('system'),
          brands: formatOptionForSelect('brand'),
          countries: formatOptionForSelect('countries')
        }
      },

      filterBy () {
        return items => {
          return items.filter(item => {
            return filters(item.systemBrandConfigs, this.filterSortOptions).length
          }).sort((a, b) => {
            if (!a.projectTitle) return 1
            if (!b.projectTitle) return -1
            return this.sortBy
              ? a.projectTitle.localeCompare(b.projectTitle)
              : b.projectTitle.localeCompare(a.projectTitle)
          })
        }
      },
      filteredItems () {
        return this.filterBy(this.proxers)
      },
      filterSortOptions () {
        return {
          'system': { data: this.filters.system.value, type: 'combobox' },
          'brand': { data: this.filters.brand.value, type: 'combobox' },
          'is_enabled': { data: this.filters.status.value, type: 'combobox' },
          'countries': { data: this.filters.countries.value, type: 'combobox' }
        }
      },
      selectedItems () {
        return [
          {
            title: 'Project(s)',
            selected: [],
            key: 'projectTitle',
            select: this.formattedConfigOptions.projects,
          },
          {
            title: 'System(s)',
            selected: [],
            key: 'system',
            select: this.formattedConfigOptions.systems,
          },
          {
            title: 'Brand(s)',
            selected: [],
            key: 'brand',
            select: this.formattedConfigOptions.brands,
          },
          {
            title: 'Countries',
            selected: [],
            key: 'countries',
            select: this.formattedConfigOptions.countries,
          },
        ]
      },
      hasAnySelectedConfigs () {
        return this.filteredItems.some(proxer =>
          proxer.systemBrandConfigs?.some(config => config.isSelected)
        )
      },
    },
    methods: {
      addProjectToList ({ proxer, flag }) {
        const projectFilter = this.getBulkByKey('projectTitle')
        const projectTitle = proxer[0].projectTitle

        if (flag) {
          const uniqProject = proxer.filter(item => !this.bulkedProxers.projectTitle.includes(item))
          this.bulkedProxers.projectTitle = [ ...this.bulkedProxers.projectTitle, ...uniqProject ]

          if (!projectFilter.selected.includes(projectTitle)) {
            projectFilter.selected = [ ...projectFilter.selected, projectTitle ]
          }
        } else {
          this.bulkedProxers.projectTitle = this.bulkedProxers.projectTitle.filter(project => !proxer.includes(project))
          projectFilter.selected = projectFilter.selected.filter(name => name !== projectTitle)
        }
      },
      getBulkByKey (bulkKey) {
        return this.selectedItems.find(({ key }) => key === bulkKey)
      },
      isAllSelectedInProjectConfig (proxer) {
        return proxer.systemBrandConfigs.every((item) => item.isSelected)
      },
      updateSystemToList (added, element, proxer) {
        const projectFilter = this.getBulkByKey('projectTitle')
        const projectTitle = proxer.systemBrandConfigs[0].projectTitle

        if (!added) {
          this.bulkedProxers.projectTitle = this.bulkedProxers.projectTitle.filter(item => item.accesslist_id !== element?.accesslist_id)
          projectFilter.selected = projectFilter.selected.filter(name => name !== projectTitle)
        } else {
          const list = this.bulkedProxers.projectTitle
          const exists = list.some(item => item.accesslist_id === element?.accesslist_id)
          if (!exists) {
            this.bulkedProxers.projectTitle = [ ...this.bulkedProxers.projectTitle, element ]
          }
          if (this.isAllSelectedInProjectConfig(proxer) && !projectFilter.selected.includes(projectTitle)) {
            projectFilter.selected = [ ...projectFilter.selected, projectTitle ]
          }
        }
      },
      saveProxerSetting () {
        this.openSettingForm = false
        this.get()
      },
      deleteBulkedFilter () {
        this.bulkedProxers = _.cloneDeep(SKELETON_BULKED_PROXERS)
        for (const item of this.selectedItems) {
          item.selected = []
        }

        for (const proxer of this.filteredItems) {
          for (const config of proxer.systemBrandConfigs) {
            this.$set(config, 'isSelected', false)
          }
        }

        this.selectedFlag = false
      },
      async handleBulkChange (item) {
        let configs = []

        for (const proxer of this.filteredItems) {
          for (const config of proxer.systemBrandConfigs) {
            let isSelected = false

            for (const selectedItem of this.selectedItems) {
              const value = _.get(config, selectedItem.key)

              const isSelectedInGroup = Array.isArray(value)
                ? _.intersection(selectedItem.selected, value).length > 0
                : selectedItem.selected.includes(value)

              if (isSelectedInGroup) {
                isSelected = true
                break
              }
            }

            this.$set(config, 'isSelected', isSelected)
            await this.$nextTick()
          }

          const foundConfigs = proxer.systemBrandConfigs.filter(config => config.isSelected)
          configs = configs.concat(foundConfigs)
        }

        if (item.selected && item.selected.length > 0) {
          configs = configs.filter(config => {
            const value = _.get(config, item.key)

            return Array.isArray(value)
              ? _.intersection(value, item.selected).length > 0
              : item.selected.includes(value)
          })
        }

        this.bulkedProxers[item.key] = item.selected.length ? configs : []
        this.updateSelectedFlag()
      },

      updateSelectedFlag () {
        const allConfigs = _.flatMap(this.filteredItems, 'systemBrandConfigs')
        this.selectedFlag = allConfigs.length > 0 && _.every(allConfigs, 'isSelected')
      },
      async applyBulkAction () {
        try {
          this.isLoadingBulk = true
          const endpoint = this.action ? 'enable' : 'disable'
          const proxers = this.uniqBulkedProxers.map(({ entity_id, brand_id }) => ({ entity_id, brand_id }))
          await API.call(`/$v/proxer/access/${endpoint}.json`, { proxers })

          this.$notification.show = true
          this.$notification.message = `Proxies ${endpoint} is successful`
          this.$notification.type = 'success'
          this.deleteBulkedFilter()
          this.chooseAll(false)
          this.get()
        } catch (e) {
        } finally {
          this.isLoadingBulk = false
        }
      },

      sortByTitle (filteredItems, _, [ sortDesc ]) {
        return filteredItems.sort((a, b) => sortDesc
          ? a.projectTitle - b.projectTitle
          : b.projectTitle - a.projectTitle
        )
      },

      switchProxerStatus (isEnabledData) {
        let index = findIndex(this.proxers, { entity_id: isEnabledData.proxerData.entity_id })
        this.$set(this.proxers, index, isEnabledData.proxerData)

        const params = {
          entity_id: isEnabledData.entity_id
        }

        isEnabledData.params.hasOwnProperty('all')
          ? params.all = isEnabledData.params.all
          : params.brand_id = isEnabledData.params.brand_id

        isEnabledData.key
          ? this.enable(params)
          : this.disable(params)
      },
      addNewProxer () {
        this.currentSettingData = null
        this.isNewNotification = true
        this.openSettingForm = true
      },
      editProxer (proxer) {
        this.currentSettingData = proxer
        this.isNewProxer = false
        this.openSettingForm = true
      },
      chooseAll (flag) {
        this.selectedFlag = flag
        const projectFilter = this.getBulkByKey('projectTitle')
        if (flag) {
          for (const proxer of this.filteredItems) {
            for (const config of (proxer?.systemBrandConfigs ?? [])) {
              config.isSelected = true
              this.bulkedProxers.projectTitle.push(config)
            }
          }
          projectFilter.selected = [ ...projectFilter.select.map(({ text }) => text) ]
        } else {
          for (const proxer of this.filteredItems) {
            for (const config of (proxer?.systemBrandConfigs ?? [])) {
              config.isSelected = false
            }
          }
          this.bulkedProxers.projectTitle = []
          projectFilter.selected = []
          this.deleteBulkedFilter()
        }
      },
      async getProviders () {
        const result = await API.call('/$v/proxer/access/get_providers.json', {})
        this.providers = result.data
      },
      async get () {
        this.isLoading = true
        try {
          const result = await API.call('/$v/proxer/access/get.json', {
            entities: this.$store.state.auth.entities
          })
          this.brandList = result.data.brandList
          this.entitiesMap = result.data.entitiesMap
          this.proxers = result.data.proxers.map(proxer => ({
              ...proxer,
              systemBrandConfigs: proxer.systemBrandConfigs.map(
                config => ({ ...config, isSelected: false }))
            })
          )
          this.systemList = result.data.systemList
        } catch (e) {
        } finally {
          this.isLoading = false
        }
      },
      enable (params) {
        API.call('/$v/proxer/access/enable.json', params)
      },
      disable (params) {
        API.call('/$v/proxer/access/disable.json', params)
      },
    }
  }
</script>
<style lang="scss" scoped>

  .bulk-selects {
    display: flex;
    gap: 16px;
  }

  ::v-deep.checkbox {
    width: 38px;
    display: flex;
    justify-content: center;

    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }

  ::v-deep.bulk-actions-select {
    &-others {
      white-space: nowrap !important;
    }

    .v-select__selections {
      color: #4EAF50 !important;
      max-width: 160px;
      overflow: hidden;
      flex-wrap: nowrap;

      .body-2 {
        white-space: nowrap !important;
      }
    }
  }
</style>
